// Copyright aptihealth, inc. 2022 All Rights Reserved
import React, { useState } from "react";
import ProfileDetailsCard from "../../Provider/Profile/ProfileDetailsCard";
import { getAutomationDataAttr } from "../../../utils/automationUtils";
import CalendarPreferencesModal from "./CalendarPreferencesModal";
import { toTitleCase } from "../../../utils/filters";
import { isUserPeerOrCM } from "../../../redux/actions/auth";

const CalendarPreferences = (props) => {
  const { preferences, updateProfileApiFunction } = props;
  const [showPreferencesModal, setShowPreferencesModal] = useState(false);
  const [tempPreferences, setTempPreferences] = useState(() => {
    const defaultPreferences = {
      calendar: { events: ["scheduled"], view: "DAY" },
      time_zone: "US/Eastern",
    };

    if (!preferences) {
      return defaultPreferences;
    }

    return {
      ...defaultPreferences,
      ...preferences,
      calendar: {
        ...defaultPreferences.calendar,
        ...preferences.calendar,
      },
    };
  });

  const updatePreferences = async (newPreferences) => {
    try {
      await updateProfileApiFunction(newPreferences);
      setTempPreferences(newPreferences);
    } catch (err) {
      console.error("Failed to update preferences:", err);
    }
  };

  const calendarView = toTitleCase(tempPreferences.calendar?.view || "DAY");

  return (
    <>
      {showPreferencesModal && (
        <CalendarPreferencesModal
          preferences={tempPreferences}
          updatePreferences={updatePreferences}
          closeModal={() => setShowPreferencesModal(false)}
        />
      )}
      <ProfileDetailsCard
        heading="Calendar Preferences"
        onclick={() => setShowPreferencesModal(true)}
        testId="CalendarPreferences"
      >
        <div className="my-2 pt-4 px-2" data-public="true">
          <div className="d-flex mb-4">
            <div className="d-flex flex-column pr-4">
              <label className="fs-14 tw:font-bold">Time Zone</label>
              <p className="ProviderProfile__toUpdateMessage mb-2">
                To update your time zone, contact{" "}
                <a href="mailto:support@aptihealth.com">support@aptihealth.com</a>
              </p>
              <span {...getAutomationDataAttr("ProviderTimeZone")} className="text-muted">
                {tempPreferences.time_zone}
              </span>
            </div>
          </div>
          <div className="d-flex mb-4">
            <div className="d-flex flex-column pr-4">
              <label className="fs-14 tw:font-bold">Default Calendar View</label>
              <span {...getAutomationDataAttr("CalendarView")}>{calendarView}</span>
            </div>
          </div>
          {!isUserPeerOrCM() && (
            <div className="d-flex mb-4">
              <div className="d-flex flex-column pr-4">
                <label className="fs-14 tw:font-bold">Events Shown by Default</label>
                <p className="ProviderProfile__toUpdateMessage mb-2">
                  Choose which types of events appear on your calendar by default. You can update
                  this view anytime using filters.
                </p>
                <span {...getAutomationDataAttr("CalendarEvents")}>
                  <ul>
                    {(tempPreferences.calendar?.events || []).map((event) => (
                      <li key={"provider-preferences-event-" + event} className="d-flex">
                        {toTitleCase(event.replace("_", " "))}
                      </li>
                    ))}
                  </ul>
                </span>
              </div>
            </div>
          )}
        </div>
      </ProfileDetailsCard>
    </>
  );
};

export default CalendarPreferences;
